'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
exports.get = get;
exports.post = post;
exports.patch = patch;
exports.put = put;
exports.del = del;
var _fetchUrl = require('./fetchUrl');
var _errors = require('./errors');
function fetchUrlAlias(method, url, data, fetchOptions, fetchUrlOptions) {
  if (method === 'PATCH') {
    throw new _errors.InvalidPatchError('PATCH should not be used for externally facing APIs. Instead PATCH via POST with X-HTTP-Method-Override=PATCH, to avoid content firewalls', url, data, fetchOptions, fetchUrlOptions);
  }
  return (0, _fetchUrl.fetchUrl)(url, _extends({}, fetchOptions, {
    method: method,
    body: JSON.stringify(data)
  }), _extends({}, fetchUrlOptions));
}
// Provided for API symmetry
function get(url, fetchOptions, fetchUrlOptions) {
  return fetchUrlAlias('GET', url, undefined, fetchOptions, fetchUrlOptions);
}
function post(url, data, fetchOptions, fetchUrlOptions) {
  return fetchUrlAlias('POST', url, data, fetchOptions, fetchUrlOptions);
}

// The ability to PATCH via POST should be used for externally facing APIs,
// to get around content firewalls. See XPR-55 for more detail.
function patch(url, data, fetchOptions, fetchUrlOptions) {
  return fetchUrlAlias('PATCH', url, data, fetchOptions, fetchUrlOptions);
}
function put(url, data, fetchOptions, fetchUrlOptions) {
  return fetchUrlAlias('PUT', url, data, fetchOptions, fetchUrlOptions);
}
function del(url, data, fetchOptions, fetchUrlOptions) {
  return fetchUrlAlias('DELETE', url, data, fetchOptions, fetchUrlOptions);
}